import { createEffect, sample } from 'effector';
import { createGate } from 'effector-react';
import { cache, createQuery } from '@farfetched/core';
import {
  ApartmentGate,
  ApartmentRequest,
  ApartmentResponse,
} from '@features/effector-form/controls/apartment/types';
import { getApartments } from './api';

export const ApartmentControlGate = createGate<ApartmentGate>();

const fxGetApartments = createEffect<ApartmentRequest, ApartmentResponse, Error>().use(
  getApartments
);

export const apartmentsQuery = createQuery({
  name: 'apartments',
  effect: fxGetApartments,
  mapData: ({ result }) =>
    result.items.map(({ apartment }) => ({
      id: apartment.id,
      label: apartment.title,
    })),
});

cache(apartmentsQuery);

sample({
  clock: ApartmentControlGate.state,
  source: ApartmentControlGate.status,
  filter: (status, data) =>
    !!(
      status &&
      (data.building || (Array.isArray(data.buildingIds) && data.buildingIds.length > 0))
    ),
  fn: (_, data) => ({
    complex_id: data.complex,
    building_id: data.building,
    building_ids: data.buildingIds,
  }),
  target: apartmentsQuery.start,
});
